var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 284.047,
    height: 106.7,
    viewBox: "0 0 75.154 28.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.935 604.192v10.29h10.863v4.895h-10.863v6.159h11.82v5.01h-17.557v-26.354zM328.785 604.192v19.087h-5.508v-19.087zm-.038 25.092c0 2.142-1.071 2.792-2.678 2.792-1.683 0-2.792-.803-2.792-2.83 0-2.142 1.224-2.83 2.792-2.83 1.683 0 2.678.803 2.678 2.868zM336.74 604.192c2.64 4.284 3.213 5.317 3.787 6.235.612-1.148 1.186-1.989 3.94-6.235h6.885l-6.732 10.022 6.35 9.065h-6.12c-2.487-3.787-3.06-4.82-3.711-5.89-.612 1.07-1.262 2.141-3.748 5.89h-6.77l6.387-9.333-6.655-9.754zM365.252 604.154l-.191 3.863c-.46-.038-1.186-.038-1.951-.038-1.148 0-1.798.306-2.142.765-.306.42-.42 1.186-.42 2.372v7.917h4.474v4.246h-4.475v5.584h-5.164c-.23-5.393-.23-5.584-.23-5.584h-2.983v-4.246h2.87v-8.338c0-2.945.535-4.399 1.453-5.393.841-.918 2.792-1.492 4.437-1.492 1.338 0 2.945.076 4.322.344z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 30,
      lineHeight: 1.25,
      fontFamily: "Qubo",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.95624143
    },
    transform: "matrix(.61944 0 0 -.61944 -151.097 396.894)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-7.582-2.32a3.656 3.656 0 0 1-2.014-1.528 3.658 3.658 0 0 1-.486-2.802l1.782-7.726c.406-1.762-.45-3.255-1.739-3.999-1.289-.745-3.011-.74-4.334.493l-5.799 5.406a3.655 3.655 0 0 1-2.499.984 3.65 3.65 0 0 1-2.501-.984l-5.801-5.406c-1.322-1.233-3.044-1.238-4.333-.493-1.289.744-2.146 2.237-1.739 3.999l1.782 7.726a3.665 3.665 0 0 1-2.5 4.33L-45.345 0c-1.729.529-2.593 2.017-2.594 3.505 0 1.489.864 2.978 2.594 3.507l7.582 2.32c.92.282 1.653.896 2.102 1.673.449.778.614 1.719.398 2.657l-1.782 7.726c-.407 1.762.45 3.255 1.739 3.999 1.289.745 3.011.74 4.333-.492l5.801-5.407a3.657 3.657 0 0 1 2.463-.984 3.66 3.66 0 0 1 2.537.984l5.799 5.407c1.323 1.232 3.045 1.237 4.334.492 1.289-.744 2.145-2.237 1.739-3.999l-1.782-7.726a3.654 3.654 0 0 1 .261-2.396 3.663 3.663 0 0 1 2.239-1.934L0 7.012c1.729-.529 2.594-2.017 2.594-3.506C2.594 2.018 1.729.529 0 0m-22.672 43.519c-15.338 0-28.661-8.631-35.376-21.301a39.83 39.83 0 0 1-4.637-18.712c0-11.049 4.479-21.052 11.72-28.293 7.24-7.24 17.244-11.719 28.293-11.719 11.957 0 22.69 5.245 30.022 13.561a39.862 39.862 0 0 1 9.99 26.451c0 11.551-4.895 21.958-12.723 29.262-7.148 6.67-16.742 10.751-27.289 10.751",
    style: {
      fill: "#00aeef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 22.114 15.353)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.091e5c9c9b2e828257602d00ce71e233.svg";
export { ForwardRef as ReactComponent };